'use client';

import Link from 'next/link';
import { AnimateIn } from '@/components/ui/AnimateIn';
import { trackCTAClick } from '@/lib/analytics';

export default function CTA({
    heading,
    subtext,
    primaryButton,
    secondaryButton,
    ctaSection,
}) {
    return (
        <section className="w-full bg-linear-to-r from-brand to-brand-dark text-white">
            <div className="w-full max-w-7xl mx-auto pt-16 pb-8 text-center px-4 sm:px-6 lg:px-8">
                <AnimateIn trigger="mount" className="w-full">
                    <h2 className="w-full text-center text-3xl font-bold mb-4">
                        {heading}
                    </h2>
                    <p className="text-lg mb-8 max-w-2xl lg:w-1/2 mx-auto px-4 md:px-0 text-white/80">
                        {subtext}
                    </p>
                    <div className="flex flex-row flex-wrap gap-4 justify-center px-4 md:px-0">
                        <Link
                            href={primaryButton.href}
                            onClick={() =>
                                trackCTAClick(primaryButton.trackingLabel, {
                                    cta_section: ctaSection,
                                    cta_type: 'primary',
                                })
                            }
                            className="bg-white text-brand-dark px-8 py-3 uppercase tracking-wide hover:bg-gray-100 transition duration-300 font-semibold w-full sm:w-auto flex items-center justify-center cursor-pointer"
                        >
                            {primaryButton.icon}
                            {primaryButton.label}
                        </Link>
                        {secondaryButton && (
                            <Link
                                href={secondaryButton.href}
                                onClick={() =>
                                    trackCTAClick(
                                        secondaryButton.trackingLabel,
                                        {
                                            cta_section: ctaSection,
                                            cta_type: 'secondary',
                                        },
                                    )
                                }
                                className="bg-transparent border-2 border-white text-white px-8 py-3 uppercase tracking-wide hover:bg-white/10 transition duration-300 font-medium w-full sm:w-auto flex items-center justify-center cursor-pointer"
                            >
                                {secondaryButton.icon}
                                {secondaryButton.label}
                            </Link>
                        )}
                    </div>
                </AnimateIn>
            </div>
        </section>
    );
}
